export const formatNumberWithParens = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return ''
  }

  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '')

  if (cleaned.length !== 10) {
    return phoneNumber
  }

  const areaCode = cleaned.substring(0, 3)
  const firstPart = cleaned.substring(3, 6)
  const secondPart = cleaned.substring(6, 10)

  return `(${areaCode}) ${firstPart}-${secondPart}`
}

export const toNumeric = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return ''
  }

  // Remove all non-numeric characters
  return phoneNumber.replace(/\D/g, '')
}
